import { Pages } from '@/util/settings/enums';
const isDevelopment = process.env.NODE_ENV === 'development';
export default {
    app: {
        signInPath: isDevelopment ? Pages.SIGNIN : '#{Path:SignIn}'
    },
    url: {
        api: {
            languageContentApi: isDevelopment
                ? 'https://testcms.gmc-uk.org/languagecontentapi'
                : '#{App:LanguageContentApi}',
            gmcConnectApi: isDevelopment ? 'https://s1devintmw01.gmc-uk.org:109' : '#{App:GmcConnectApi}'
        },
        siebel: {
            siebelStepTwoUrl: isDevelopment ? 'https://www.google.com' : '#{App:SiebelStepTwoUrl}'
        },
        redirect: {
            profileConnectIdClaimExistsRedirectUrl: isDevelopment
                ? 'https://www.google.com'
                : '#{App:ProfileConnectIdClaimExistsRedirect}',
            baseRedirectUrl: isDevelopment ? window.location.origin : '#{App:baseRedirectUrl}'
        }
    },
    azureAd: {
        instance: isDevelopment ? 'extgmcukorg' : '#{App:AzureAd:Instance}',
        clientId: isDevelopment ? 'cfc002f9-cdde-4079-ba09-adac74933952' : '#{App:AzureAd:ClientId}',
        policyNameSignUp: isDevelopment
            ? 'B2C_1A_UserSignUpGMCConnect'
            : '#{Policy:Prefix}#{Policy:Name:UserSignUpGMCConnect}',
        policyNameSignInOrMigrate: isDevelopment
            ? 'B2C_1A_UserSignInOrMigrateGMCConnect'
            : '#{Policy:Prefix}#{Policy:Name:UserSignInOrMigrateGMCConnect}',
        policyNameSignInExisting: isDevelopment
            ? 'B2C_1A_UserExistingAccountSignInGMCConnect'
            : '#{Policy:Prefix}#{Policy:Name:UserExistingAccountSignInGMCConnect}'
    }
};
